// TextWaiverModal.jsx
import React from "react";
import useTranslation from "../../i18n/useTranslation";

export default function TextWaiverModal({ content, onClose }) {
    const { t } = useTranslation();

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content" style={{ maxHeight: "90vh" }}>
                    <div className="modal-header bg-dark">
                        <h5 className="modal-title">{t("textWaiverModal.title")}</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={onClose}
                            aria-label={t("textWaiverModal.close")}
                            title={t("textWaiverModal.close")}
                        >
                            <span>&times;</span>
                        </button>
                    </div>
                    <div
                        className="modal-body"
                        style={{
                            overflowY: "auto",
                            maxHeight: "70vh",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <p>{content}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}